import React, { useEffect, useState } from 'react';
import axiosInstance from '../util/axiosConfig';
import useVendorsForModal from '../hooks/useVendorsForModal';
import StockFormModal from './StockFormModal';
import EquipmentForm, {
  emptyEquipmentForm,
  equipmentFormToPayload,
  validateEquipmentForm
} from './EquipmentForm';

const AddEquipmentModal = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState(emptyEquipmentForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { vendors, vendorsLoading } = useVendorsForModal(open);

  useEffect(() => {
    if (!open) return;
    setForm(emptyEquipmentForm());
    setError('');
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const message = validateEquipmentForm(form);
    if (message) {
      setError(message);
      return;
    }
    try {
      setSubmitting(true);
      await axiosInstance.post('/equipment', equipmentFormToPayload(form));
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add equipment');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <StockFormModal
      open={open}
      onClose={onClose}
      title="Add Equipment"
      error={error}
      onErrorClose={() => setError('')}
    >
      <EquipmentForm
        form={form}
        onChange={handleChange}
        onSubmit={handleSubmit}
        loading={submitting}
        vendors={vendors}
        vendorsLoading={vendorsLoading}
        fullWidthSubmit={false}
      />
    </StockFormModal>
  );
};

export default AddEquipmentModal;
